// extracted by mini-css-extract-plugin
module.exports = {"background":"bc_fb","shopping__wrapper__examples":"bc_fc","active":"bc_fd","shopping__wrapper__project":"bc_ff"};